export const dataLibP = [{
  word: 'pen',
  partOfSpeech: 'N',
  definition: ['bread'],
  egSentenceKw: 'Bonmaten-an i ka fè pen.',
  egSentenceEn: 'This morning she is making bread.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. pain]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pòpòt',
  partOfSpeech: 'N',
  definition: ['doll'],
  egSentenceKw: 'Achté an pòpòt bay tifi-a.',
  egSentenceEn: 'Buy a doll for the girl.',
  synonym: ['bolonm'],
  antonym: [null],
  etymology: '[< Fr. popote]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pòt',
  partOfSpeech: 'N',
  definition: ['can', 'tin', 'enamel cup'],
  egSentenceKw: 'Nou genyen senk pòt lèt.',
  egSentenceEn: 'We bought five cans of milk.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. pot]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pawasòl',
  partOfSpeech: 'N',
  definition: ['umbrella', 'parasol'],
  egSentenceKw: 'Sé pou ou maché épi pawasòl ou jòdi-a; i kay fè lapli.',
  egSentenceEn: 'You must carry your umbrella today; it is going to rain.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. parasol]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pou',
  partOfSpeech: 'PREP',
  definition: ['for (in the sense of duration)'],
  egSentenceKw: 'I wété la pou twa simenn.',
  egSentenceEn: 'He stayed there for three weeks.',
  synonym: ['apwézan', 'atjwèlman'],
  antonym: [null],
  etymology: '[< Fr. pour]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'papa',
  partOfSpeech: 'N',
  definition: ['father'],
  egSentenceKw: 'Papa\'y té ja an vyéyès li lè i fè dènyé gason\'y.',
  egSentenceEn: 'His father was already in his old age when he had his last son.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. papa]',
  dialect: '🇱🇨',
  variant: 'Apa',
}, {
  word: 'pa',
  partOfSpeech: 'ADV',
  definition: ['not'],
  egSentenceKw: 'Sa pa vwé!',
  egSentenceEn: 'That\'s not true!',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. pas]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pa',
  partOfSpeech: 'PREP',
  definition: ['by', 'through'],
  egSentenceKw: 'Sé Bondyé ki sové\'w pa lagwas li.',
  egSentenceEn: 'It is God who saved you by his grace.',
  synonym: ['li'],
  antonym: [null],
  etymology: '[< Fr. papa]',
  dialect: '🇱🇨',
  variant: 'Apa',
}, {
  word: 'pòté',
  partOfSpeech: 'V',
  definition: ['to carry', 'to bring'],
  egSentenceKw: 'I ka pòté bwèt-la.',
  egSentenceEn: 'He\'s carrying the box.',
  synonym: ['chayé', 'mennen fwi'],
  antonym: [null],
  etymology: '[< Fr. porter]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pòté',
  partOfSpeech: 'V',
  definition: ['to wear'],
  egSentenceKw: 'I ka pòté soulyé nwè.',
  egSentenceEn: 'He\'s wearing black shoes.',
  synonym: ['mennen fwi'],
  antonym: [null],
  etymology: '[< Fr. porter]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pèd',
  partOfSpeech: 'V',
  definition: ['to lose', 'to get lost'],
  egSentenceKw: 'Gason-an pèd lajan-an.',
  egSentenceEn: 'The boy lost the money.',
  synonym: [null],
  antonym: ['bat', 'twapé', 'twouvé'],
  etymology: '[< Fr. perdre]',
  dialect: '🇱🇨',
  variant: ['pèdi'],
}, {
  word: 'pèd',
  partOfSpeech: 'ADJ',
  definition: ['lost'],
  egSentenceKw: 'Nou ka aché ti manmay-la ki pèd-la.',
  egSentenceEn: 'We are looking for the lost child.',
  synonym: [null],
  antonym: ['jwenn', 'twapé', 'twouvé'],
  etymology: '[< Fr. perdre]',
  dialect: '🇱🇨',
  variant: ['pèdi'],
}, {
  word: 'panyt',
  partOfSpeech: 'N',
  definition: ['pint'],
  egSentenceKw: 'Ban mwen on panyt lèt.',
  egSentenceEn: 'Give me a pint of milk.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. pint]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pitj',
  partOfSpeech: 'N',
  definition: ['to pave with asphalt'],
  egSentenceKw: 'Fini yo fini pitj chimen-an, i ja ka kwazé ankò.',
  egSentenceEn: 'They just finished paving the road and it is already collapsing again.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. pitch]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'plasta',
  partOfSpeech: 'N',
  definition: ['bandage'],
  egSentenceKw: 'I mété on plasta asou jounou\'y.',
  egSentenceEn: 'She put a bandage on her knee.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. plaster]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'plég',
  partOfSpeech: 'N',
  definition: ['plague'],
  egSentenceKw: 'Maladi sala ka simen kon on plég.',
  egSentenceEn: 'This sickness is spreading like a plague.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. plague]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'plén',
  partOfSpeech: 'N',
  definition: ['plane'],
  egSentenceKw: 'Plén-an wivé ta.',
  egSentenceEn: 'The plane arrived late.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. plane]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pwotéjé',
  partOfSpeech: 'V',
  definition: ['to protect'],
  egSentenceKw: 'Papa\'y ka pwotéjé\'y',
  egSentenceEn: 'His father protects him.',
  synonym: ['pwotèkté'],
  antonym: [null],
  etymology: '[< Fr. protéger]',
  dialect: '🇱🇨',
  variant: ['potéjé'],
}, {
  word: 'pwotéjé',
  partOfSpeech: 'V',
  definition: ['to protect'],
  egSentenceKw: 'Bondyé ka pwotèkté nou.',
  egSentenceEn: 'God protects us.',
  synonym: ['pwotéjé'],
  antonym: [null],
  etymology: '[< Eng. protect]',
  dialect: '🇱🇨',
  variant: ['potèkté'],
}, {
  word: 'palé',
  partOfSpeech: 'V',
  definition: ['to speak', 'to talk'],
  egSentenceKw: 'I ka palé Kwéyòl.',
  egSentenceEn: 'He speaks Creole.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. parler]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pwan',
  partOfSpeech: 'V',
  definition: ['to take'],
  egSentenceKw: 'Nou kay pwan lajan-an.',
  egSentenceEn: 'We\'ll take the money.',
  synonym: ['fè vis', 'fwékanté', 'kouché', 'koumansé', 'mété', 'pitjé'],
  antonym: [null],
  etymology: '[< Fr. prendre]',
  dialect: '🇱🇨',
  variant: ['pwen'],
}, {
  word: 'pou',
  partOfSpeech: 'PREP',
  definition: ['for (in exchange for)'],
  egSentenceKw: 'Mwen vann dé bwapen ba li pou dé dòla.',
  egSentenceEn: 'I sold him two breadfruits for two dollars.',
  synonym: ['apwézan', 'atjwèlman'],
  antonym: [null],
  etymology: '[< Fr. pour]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pou',
  partOfSpeech: 'PREP',
  definition: ['for', 'because of'],
  egSentenceKw: 'Nou wimèsyé\'y pou bon potjiwasyon-an.',
  egSentenceEn: 'We thanked him for the good provision.',
  synonym: ['apwézan', 'atjwèlman'],
  antonym: [null],
  etymology: '[< Fr. pour]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pou',
  partOfSpeech: 'PREP',
  definition: ['to', 'in order to'],
  egSentenceKw: 'I vini pou apwann palé Patwa.',
  egSentenceEn: 'He came in order to learn Patwa.',
  synonym: ['apwézan', 'atjwèlman'],
  antonym: [null],
  etymology: '[< Fr. pour]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pwé',
  partOfSpeech: 'PREP',
  definition: ['near'],
  egSentenceKw: 'Nou pa té pwé\'y.',
  egSentenceEn: 'We weren\'t near him.',
  synonym: [null],
  antonym: ['lwen'],
  etymology: '[< Fr. près]',
  dialect: '🇱🇨',
  variant: ['opwé'],
}, {
  word: 'pwé',
  partOfSpeech: 'PREP',
  definition: ['near', 'nearby'],
  egSentenceKw: 'Lè i vini pwé, nou wè\'y.',
  egSentenceEn: 'When he came near, we saw him.',
  synonym: [null],
  antonym: ['lwen'],
  etymology: '[< Fr. près]',
  dialect: '🇱🇨',
  variant: ['opwé'],
}, {
  word: 'pèdwi',
  partOfSpeech: 'N',
  definition: ['wild dove'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pélékan',
  partOfSpeech: 'N',
  definition: ['pelican', '(Pelecanus occidentalis)'],
  egSentenceKw: 'Pélékan ka plonjé anba lanmè-a pou tjébé pwéson.',
  egSentenceEn: 'Pelicans dive into the sea to catch fish.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. pélican]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pijon',
  partOfSpeech: 'N',
  definition: ['pigeon'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. .pigeon]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pipirit',
  partOfSpeech: 'N',
  definition: ['grey kingbird', '(Tyrannus dominicensis)'],
  egSentenceKw: 'Pipirit-la pété an zòy an tèt malfini-an.',
  egSentenceEn: 'The kingbird pecked the hawk\'s head.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'poul',
  partOfSpeech: 'N',
  definition: ['hen', 'chicken', 'fowl'],
  egSentenceKw: 'Tout sé poul mwen-an ja ka ponn.',
  egSentenceEn: 'All of my hens are already laying eggs.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. .poulet]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pitjwit',
  partOfSpeech: 'N',
  definition: ['spotted sandpiper', '(Actitis macularia)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'paski',
  partOfSpeech: 'CONJ',
  definition: ['because'],
  egSentenceKw: 'I té faché paski i pa té ni pyès lajan.',
  egSentenceEn: 'He was angry because he didn\'t have any money.',
  synonym: ['davwa', 'pas pouki'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['paspas', 'pouki', 'paskè', 'pis', 'piski'],
}, {
  word: 'pyé',
  partOfSpeech: 'N',
  definition: ['foot (as a part of the body)'],
  egSentenceKw: 'Mwen té kay sèpé pyé\'y.',
  egSentenceEn: 'I would have cut off his foot.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. pied]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pyé',
  partOfSpeech: 'N',
  definition: ['foot (as a length of measure)'],
  egSentenceKw: 'Mwen achté on poto dis pyé.',
  egSentenceEn: 'I bought a ten-foot long post.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. pied]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pyé',
  partOfSpeech: 'N',
  definition: ['plant', 'bush', 'tree'],
  egSentenceKw: 'I ban mwen dé pyé mango pou mwen sa planté.',
  egSentenceEn: 'He gave me two mango trees to plant.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. pieds]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pyès',
  partOfSpeech: 'N',
  definition: ['coin'],
  egSentenceKw: 'Ti manmay-la pèd pyès lajan-an.',
  egSentenceEn: 'The child lost the coin.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. pièce]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pyès',
  partOfSpeech: 'N',
  definition: ['patch (on clothing)'],
  egSentenceKw: 'I mété on gwo pyès an do chimiz-la.',
  egSentenceEn: 'She put a big patch on the back of the shirt.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. pièce]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pyès',
  partOfSpeech: 'N',
  definition: ['field', 'piece of land'],
  egSentenceKw: 'Ou planté on bèl pyès fig an hòtè.',
  egSentenceEn: 'You planted a nice banana field in the countryside.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. pièce]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pyès',
  partOfSpeech: 'ADJ',
  definition: ['not any', 'none at all'],
  egSentenceKw: 'Ou pa ni pyès wézon pou alé la.',
  egSentenceEn: 'You don\'t have any reason to go there.',
  synonym: [null],
  antonym: ['tout'],
  etymology: '[< Fr. pièce]',
  dialect: '🇱🇨',
  variant: [null],
},
];
